module.exports = __webpack_public_path__ + "img/dypitch-2.08402e3d.jpg";